import RegexHelper from './RegexHelper'

const AVAILABLE_LANGUAGES = ['en', 'fr', 'nl']
const DEFAULT_LOCALE = 'en'

const getCurrentLocale = (userPreferredLanguage = null) => {
    const pathname = window.location.pathname
    
    const languageMatch = pathname.match(RegexHelper.languageRegex)
    
    if (languageMatch && languageMatch[1]) {
        const lang = languageMatch[1].toLowerCase()
        
        if (AVAILABLE_LANGUAGES.includes(lang)) {
            return lang
        }
    }
    
    return DEFAULT_LOCALE
}

const getAvailableLanguages = () => {
    return AVAILABLE_LANGUAGES
}

export default {
    getCurrentLocale,
    getAvailableLanguages,
    DEFAULT_LOCALE
} 